export default {
  init() {

    const heroes = document.querySelectorAll('[data-hero]');
    const contents = document.querySelectorAll('[data-content]');
    const buttons = document.querySelectorAll('[data-toggle-button]');

    if (buttons.length == 0 || contents.length == 0 || heroes.length == 0) return;

    const buttonDataForValues = Array.from(buttons).map(button => button.dataset.for);

    // Get the active tab from the URL and default to the first button if empty or not in the buttonDataForValues array
    let activeTab = window.location.hash.replace('#', '');

    if (!activeTab || !buttonDataForValues.includes(activeTab)) {
      activeTab = buttons[0].dataset.for;
    }

    toggleContent();

    // Listen to clicks on button
    buttons.forEach(button => {
      button.addEventListener('click', (e) => handleButtonClick(e, button));
    });


    /**
     * Handle the click event on a button
     * @param {DOMElement} button
     */
    function handleButtonClick(e, button) {

      e.preventDefault();

      activeTab = button.dataset.for;

      // Set the url hash to the active tab
      window.location.hash = activeTab;

      toggleContent();

    }

    /**
     * Toggle the content and buttons based on the active tab
     */
    function toggleContent(){

      // Toggle buttons
      buttons.forEach(button => {
        button.classList.toggle('active', button.dataset.for === activeTab);
      });

      // Toggle heroes
      heroes.forEach(hero => {
        hero.classList.toggle('active', hero.dataset.for === activeTab);
      });

      // Toggle contents
      contents.forEach(content => {
        content.classList.toggle('active', content.dataset.for === activeTab);
      });
    }
  }
}
